import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';
import { withGlow } from '../../helpers/with-glow';

export function buildStage1(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.circle.current,
    {
      scale: 1,
      backgroundColor: 'rgba(255,255,255,0.1)',
      duration: 3,
    },
    'stage1'
  );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage1',
    animations: [
      { x: vw(-0.17), y: vh(-0.065), duration: 3 },
      { x: vw(0.073), y: vh(-0.104), duration: 3 },
      { x: vw(0.217), y: vh(-0.013), duration: 3 },
      { x: vw(0.145), y: vh(0.091), duration: 3 },
      { x: vw(-0.048), y: vh(0.097), duration: 3 },
      { x: vw(-0.205), y: vh(0.039), duration: 3 },
    ],
    onEachStar: withGlow,
  });
}
